export const scriptLoader = (url: string) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = url;
  document.body.appendChild(script);
};
